import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChartHorizontal100Axis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStackedBarChartHorizontal100Axis"><Path d="M3 3H4.5V19.5H21V21H3V3Z" fill="currentColor"/><Path d="M20 15.5V17H14V15.5H20Z" fill="currentColor"/><Path d="M20 10.75V12.25H13V10.75H20Z" fill="currentColor"/><Path d="M20 6V7.5H16V6H20Z" fill="currentColor"/><Path d="M14 6V7.5H6V6H14Z" fill="currentColor"/><Path d="M11 10.75V12.25H6V10.75H11Z" fill="currentColor"/><Path d="M12 15.5V17H6V15.5H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChartHorizontal100Axis;
